import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { api, ApiFehler } from '../api/client'
import AppRahmen from '../komponenten/AppRahmen'
import Wortmarke from '../komponenten/Wortmarke'

/** Anmeldung mit Benutzername und Passwort; die Sitzung haelt 30 Tage. */
export default function Anmeldung() {
  const abfragen = useQueryClient()
  const [benutzername, setBenutzername] = useState('')
  const [passwort, setPasswort] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [laeuft, setLaeuft] = useState(false)

  const anmelden = async (ereignis: React.FormEvent) => {
    ereignis.preventDefault()
    setFehler(null)
    setLaeuft(true)
    try {
      await api.post('/api/auth/login', { benutzername, passwort })
      await abfragen.invalidateQueries({ queryKey: ['anmeldestatus'] })
    } catch (ausnahme) {
      setFehler(ausnahme instanceof ApiFehler ? ausnahme.message : 'Anmeldung fehlgeschlagen.')
    } finally {
      setLaeuft(false)
    }
  }

  return (
    <AppRahmen titel="Neoalto Fachlotse" unter="Anmeldung" ohneMenue>
      <div style={{ display: 'grid', placeItems: 'center', padding: '12px 0 4px' }}>
        <Wortmarke />
      </div>

      <form className="gruppe" onSubmit={anmelden} style={{ gap: 16 }}>
        <div className="feld">
          <label className="label" htmlFor="benutzername">
            Benutzername
          </label>
          <input
            id="benutzername"
            type="text"
            autoComplete="username"
            value={benutzername}
            onChange={(ereignis) => setBenutzername(ereignis.target.value)}
          />
        </div>

        <div className="feld">
          <label className="label" htmlFor="passwort">
            Passwort
          </label>
          <input
            id="passwort"
            type="password"
            autoComplete="current-password"
            value={passwort}
            onChange={(ereignis) => setPasswort(ereignis.target.value)}
          />
        </div>

        {fehler && <p className="hinweiszeile">{fehler}</p>}

        <button className="btn btn-primaer" type="submit" disabled={laeuft || !benutzername || !passwort}>
          {laeuft ? 'Anmelden …' : 'Anmelden'}
        </button>
      </form>
    </AppRahmen>
  )
}
